"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import {
  AddDocumentToLoadUploadStatus
} from "../../accounts_payable/data/types/Pb";
import { isAddDocumentToLoadEnabled } from "./add_document_to_load_enabled";
import addDocumentToLoadUpdateHandlerService from "../add_document_to_load_update_handler_service";
class AddDocumentToLoad extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "documentAddedInputElement", null);
    __publicField(this, "renderAddDocumentButton", () => {
      const wrapperStyle = {
        paddingTop: "16px",
        paddingBottom: "16px"
      };
      const inputStyle = {
        display: "none"
      };
      return /* @__PURE__ */ jsx("div", { className: "enable_shared-ui-v3", children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: "v3__theme document-browser__add-document-button-container",
          style: wrapperStyle,
          children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                onClick: (e) => this.documentAddedInputElement.click(),
                className: "v3__button v3__button--color-primary v3__button--size-small v3__button--variant-outlined",
                children: /* @__PURE__ */ jsx("span", { className: "v3__button--label-wrapper", children: "Add document" })
              }
            ),
            /* @__PURE__ */ jsx(
              "input",
              {
                type: "file",
                ref: (input) => this.documentAddedInputElement = input,
                style: inputStyle,
                onChange: this.handleFileUpload,
                multiple: true
              }
            )
          ]
        }
      ) });
    });
    __publicField(this, "processFiles", (fileList) => {
      const fileReadPromises = Array.from(fileList).map((file) => {
        return new Promise(
          (resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              var _a;
              return resolve((_a = event.target) == null ? void 0 : _a.result);
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
          }
        );
      });
      return Promise.all(fileReadPromises);
    });
    __publicField(this, "handleFileUpload", (e) => __async(this, null, function* () {
      e.preventDefault();
      addDocumentToLoadUpdateHandlerService.notifyInProgress();
      const files = e.target.files;
      if (!files) {
        return null;
      }
      try {
        const results = yield this.processFiles(files);
        const documents = results.map((result, index) => {
          if (typeof result !== "string") {
            return null;
          }
          const document = {
            fileName: files[index].name,
            mimeType: files[index].type,
            // FileReader.readAsDataURL() returns a base64 encoded string with a prefix.
            // eg. "data:*/*;base64,V2hvIGF0ZSBhbGwgdGhlIHBpZT8..."
            // We need to remove the prefix before sending the data to the server.
            base64EncodedFile: result.split(",")[1]
          };
          return document;
        });
        const payload = {
          loadId: this.props.loadState.load.id,
          carrierInvoiceId: this.props.carrierInvoice.id,
          documents: documents.filter(
            Boolean
          )
        };
        $.ajax({
          url: "/add_document_to_load_service/upload",
          type: "POST",
          contentType: "application/json",
          data: JSON.stringify(payload),
          success: (response) => {
            const uploadStatus = response.uploadStatus;
            switch (uploadStatus) {
              case AddDocumentToLoadUploadStatus.AddDocumentToLoadUploadStatusInProgress:
                break;
              case AddDocumentToLoadUploadStatus.AddDocumentToLoadUploadStatusFailed:
                addDocumentToLoadUpdateHandlerService.notifyFailure();
                break;
              default:
                console.error("Unknown upload status:", uploadStatus);
            }
          },
          error: () => addDocumentToLoadUpdateHandlerService.notifyFailure()
        });
      } catch (e2) {
        addDocumentToLoadUpdateHandlerService.notifyFailure();
      }
    }));
  }
  render() {
    const isEnabled = isAddDocumentToLoadEnabled(
      !!this.props.isConfirmAndSubmit,
      this.props.loadState,
      this.props.carrierInvoice
    );
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-component": "AddDocumentToLoad",
        className: "document-browser__add-document-wrapper",
        children: isEnabled && this.renderAddDocumentButton()
      }
    );
  }
}
export default AddDocumentToLoad;
